import { ChevronLeft, ChevronRight, Pencil } from "lucide-react";
import GutterButton from "./GutterButton";

interface EditableColumnHeaderProps {
    label: string;
    disabled: boolean;
    canMoveLeft: boolean;
    canMoveRight: boolean;
    onMoveLeft: () => void;
    onMoveRight: () => void;
    onEdit: () => void;
}

const EditableColumnHeader = (
    {
        label,
        disabled,
        canMoveLeft,
        canMoveRight,
        onMoveLeft,
        onMoveRight,
        onEdit,
    }: EditableColumnHeaderProps) => {
    return (
        <div className="flex items-stretch h-full min-h-[2.25rem]">
            <GutterButton
                icon={<ChevronLeft size={16}/>}
                label="Déplacer à gauche"
                disabled={disabled || !canMoveLeft}
                onClick={onMoveLeft}
                className="ml-1"
            />
            <div className="flex-1 flex items-stretch justify-center whitespace-nowrap">
                <span aria-hidden="true" className="w-8 shrink-0"/>
                <span className="flex items-center px-1">{label}</span>
                <GutterButton
                    icon={<Pencil size={16}/>}
                    label="Modifier la colonne"
                    disabled={disabled}
                    onClick={onEdit}
                    className="shrink-0"
                />
            </div>
            <GutterButton
                icon={<ChevronRight size={16}/>}
                label="Déplacer à droite"
                disabled={disabled || !canMoveRight}
                onClick={onMoveRight}
                className="mr-1"
            />
        </div>
    );
};

export default EditableColumnHeader;
